<template>
  <div id="container" class="gnb_pdt">
    <div class="title_wrap"><h1>접속기록통계</h1></div>

    <!-- 검색 영역 -->
    <common-area-search
        :row="1"
        :colspan="2"
        @search="allApiCall"
        @clear="cleanSearchDataEvent"
    >
      <template v-slot:R1_C1>
        <label>회사명</label>
        <ul>
          <common-multi-drop-down
              ref="cmpyCdRef"
              @change="value=>{
                  propsCmpyCd = value
                  allApiCall()
                }"
              :params="{ 'sort[0].dir': 'asc', 'sort[0].field': 'cmpyNm', searchCmpyGbnGrup : [Constant.efs.cmpyGbn.CLIENT_COMPANY] }"
              :default-index="0"
              :data-columns="[{ field: 'cmpyNm', title: '회사명', width: '60%' },{ field: 'cmpyCd', title: '회사코드', width: '40%' }]"
              :url="`${ApiConfig.efsDomain}/efs/drop-down/company`"
              :data-value-field="'cmpyCd'"
              :data-text-field="'cmpyNm'"
          >
          </common-multi-drop-down>
        </ul>
      </template>
      <template v-slot:R1_C2>
        <label>조회기간</label>
        <ul>
          <common-range-datepicker
              ref="dtRef"
              :range="{ start : defaultStartDate, end : new Date() }"
              @change="allApiCall"
          >
          </common-range-datepicker>
        </ul>
      </template>
    </common-area-search>
    <!-- //검색 영역 -->

    <!-- 요약 카드 -->
    <!--
      너비 클래스를 주지 않고 box_flex 의 균등 분배에 맡긴다.
      w20 을 5개 나열하면 카드 사이 여백까지 더해져 한 줄을 넘긴다.
      (기존 통계화면 ReportLocationList 의 상단 3분할과 동일한 방식)
    -->
    <div class="box_flex">
      <div v-for="card in summaryCardList"
           :key="card.key"
           class="contents_wrap mgt10">
        <div class="small_title_wrap w100">
          <h2>{{ card.title }}</h2>
        </div>
        <p class="acs_stat_value" :class="card.tone">
          {{ card.value }}<span class="acs_stat_unit">{{ card.unit }}</span>
        </p>
        <p class="acs_stat_desc">{{ card.desc }}</p>
      </div>
    </div>

    <!-- 일별 접속 추이 -->
    <div class="contents_wrap mgt10">
      <div class="small_title_wrap w100">
        <h2>
          일별 접속 추이
          <span class="acs_stat_period">집계기간 {{ appliedPeriodText }}</span>
        </h2>
      </div>
      <kendo-chart :render-as="'canvas'"
                   :chart-area="{background : '', height:330, margin: { top : 10, left : 0, right :0, bottom:10 }}"
                   :legend-item-click="onClickLegend"
                   :pannable-lock="'y'"
                   :transitions="chartTransitions"
                   :series="[
                        {
                          type: totalChartData.series.type,
                          data: totalChartData.series.data,
                          axis: totalChartData.series.axis,
                          visible : totalChartData.series.visible,
                          categoryField: totalChartData.series.categoryField,
                          name: constant.total,
                          field : totalChartData.series.field,
                          color: totalChartData.series.color,
                          tooltip : totalChartData.series.tooltip
                        },
                        {
                          type: loginChartData.series.type,
                          data: loginChartData.series.data,
                          axis: loginChartData.series.axis,
                          visible : loginChartData.series.visible,
                          categoryField: loginChartData.series.categoryField,
                          name: constant.login,
                          field : loginChartData.series.field,
                          color: loginChartData.series.color,
                          tooltip : loginChartData.series.tooltip
                        }]"
                   :category-axis="{
                        justified: true,
                        axisCrossingValues: [0, 999],
                      }"
                   :value-axis="[
                        totalChartData.valueAxis,
                        loginChartData.valueAxis
                      ]"
                   :legend="{
                        visible : true,
                        position : 'top',
                      }"
                   :theme="'sass'">
      </kendo-chart>
    </div>
  </div>
</template>

<script>
import EtnersCommonUtil from '@ebmp-fe-common-module/module/src/common/etners.common.util'
import EtnersDateTimeUtil from '@ebmp-fe-common-module/module/src/common/etners.datetime.util'
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'
import Constant from '@/common/constant'

export default {
  name: 'ReportAcsLogList',
  computed: {
    /**
     * 서버가 실제 적용한 집계기간. 기간을 비워 조회했거나 상한(366일)을 넘겨
     * 서버가 기간을 좁힌 경우에도 무엇이 집계되었는지 화면에서 드러나야 한다.
     */
    appliedPeriodText: function () {
      const vm = this

      if (!vm.stats.searchStartYYYYMMDD || !vm.stats.searchEndYYYYMMDD) {
        return '-'
      }

      return `${vm.toDisplayDate(vm.stats.searchStartYYYYMMDD)} ~ ${vm.toDisplayDate(vm.stats.searchEndYYYYMMDD)}`
    },
    summaryCardList: function () {
      const vm = this
      const comma = EtnersCommonUtil.numberWithCommas

      return [
        {
          key: 'totalCnt',
          title: '총 접속건수',
          value: comma(vm.stats.totalCnt),
          unit: '건',
          tone: 'blue',
          desc: '기간 내 기록된 전체 접속기록'
        },
        {
          key: 'userCnt',
          title: '접속 사용자수',
          value: comma(vm.stats.userCnt),
          unit: '명',
          tone: 'blue',
          desc: '중복 제외 고유 계정 수'
        },
        {
          key: 'loginCnt',
          title: '로그인 건수',
          value: comma(vm.stats.loginCnt),
          unit: '건',
          tone: 'green',
          desc: '수행업무가 로그인인 기록'
        },
        {
          key: 'errCnt',
          title: '오류 건수',
          value: comma(vm.stats.errCnt),
          unit: '건',
          tone: vm.stats.errCnt > 0 ? 'red' : 'gray',
          desc: '처리 중 오류가 발생한 요청'
        },
        {
          key: 'avgProcMs',
          title: '평균 처리시간',
          value: comma(vm.stats.avgProcMs),
          unit: 'ms',
          tone: 'gray',
          desc: '요청 1건당 평균 소요시간'
        }
      ]
    }
  },
  methods: {
    toDisplayDate: function (yyyymmdd) {
      if (!yyyymmdd || yyyymmdd.length !== 8) {
        return '-'
      }

      return `${yyyymmdd.substr(0, 4)}/${yyyymmdd.substr(4, 2)}/${yyyymmdd.substr(6, 2)}`
    },
    /**
     * 계열 토글. 숨긴 계열의 값축은 회색으로 눌러 어느 축이 죽었는지 보이게 한다.
     * (기존 통계화면 ReportLocationList 와 동일한 동작)
     */
    onClickLegend: function (e) {
      const vm = this
      vm.chartTransitions = false

      if (e.series.axis === vm.constant.totalAxis) {
        vm.totalChartData.series.visible = !vm.totalChartData.series.visible
        vm.$set(vm.totalChartData.valueAxis, 'color', vm.totalChartData.series.visible ? '' : '#d0d0d0')
      } else {
        vm.loginChartData.series.visible = !vm.loginChartData.series.visible
        vm.$set(vm.loginChartData.valueAxis, 'color', vm.loginChartData.series.visible ? '' : '#d0d0d0')
      }
    },
    searchFilterParam: function () {
      const vm = this
      const refs = vm.$refs

      if (!vm.propsCmpyCd) {
        return undefined
      }

      let searchFilterOptions = {
        // fms-api 는 진입 회사코드 기준으로 접속기록을 조회한다.
        // 다른 efs 화면(StkItemList 등)이 fms-api 를 호출할 때와 동일한 방식이다.
        linkCmpyCd: vm.propsCmpyCd
      }

      const range = refs.dtRef?.widget()?.range()

      if (range?.start) {
        searchFilterOptions.searchStartYYYYMMDD = EtnersDateTimeUtil.dateToYYYYMMDD(range.start)
      }

      if (range?.end) {
        searchFilterOptions.searchEndYYYYMMDD = EtnersDateTimeUtil.dateToYYYYMMDD(range.end)
      }

      return searchFilterOptions
    },
    allApiCall: function () {
      const vm = this
      const param = vm.searchFilterParam()

      // 회사를 고르지 않으면 조회할 대상 자체가 없다. 빈 화면으로 초기화만 한다.
      if (!param) {
        vm.resetStats()
        return
      }

      vm.chartTransitions = true

      ApiUtil.query(`${ApiConfig.fmsDomain}/fms/common/acs-log/stats`, param)
      .then((response) => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터가 정상적으로 조회되지 않았습니다.')
          return false
        }

        // 4042 : 조회 대상 없음. 통계 화면에서는 경고 없이 빈 상태로 그린다.
        if (response.data.resultStatus.messageCode === '4042') {
          vm.resetStats()
          return false
        }

        if (response.data.resultStatus.messageCode !== '2000') {
          vm.resetStats()
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }

        vm.stats = response.data.resultData
        vm.setChartData(vm.stats.dailyStatList)
      })
    },
    resetStats: function () {
      const vm = this

      vm.stats = vm.emptyStats()
      vm.setChartData([])
    },
    emptyStats: function () {
      return {
        totalCnt: 0,
        userCnt: 0,
        loginCnt: 0,
        errCnt: 0,
        avgProcMs: 0,
        searchStartYYYYMMDD: '',
        searchEndYYYYMMDD: '',
        dailyStatList: []
      }
    },
    setChartData: function (dailyStatList) {
      const vm = this

      const chartData = vm.toCategoryData(dailyStatList)

      vm.totalChartData = {
        series: {
          type: 'column',
          data: chartData,
          axis: vm.constant.totalAxis,
          visible: vm.totalChartData.series.visible !== false,
          categoryField: 'category',
          field: 'totalCnt',
          color: '#b7c3ff',
          tooltip: {
            visible: true,
            background: '#ffffff',
            template: `#= dataItem.MMdd # : 전체 #= kendo.format('{0:N0}', value) #건 &nbsp`
          }
        },
        valueAxis: {
          name: vm.constant.totalAxis,
          visible: true,
          ...vm.calcAxisRange(chartData, 'totalCnt'),
          labels: {
            position: 'start',
            template: `#= kendo.format('{0:N0}', value) # 건 `
          }
        }
      }

      vm.loginChartData = {
        series: {
          type: 'line',
          data: chartData,
          axis: vm.constant.loginAxis,
          visible: vm.loginChartData.series.visible !== false,
          categoryField: 'category',
          field: 'loginCnt',
          color: '#4b79d8',
          tooltip: {
            visible: true,
            background: '#ffffff',
            template: `#= dataItem.MMdd # : 로그인 #= kendo.format('{0:N0}', value) #건 &nbsp`
          }
        },
        valueAxis: {
          name: vm.constant.loginAxis,
          visible: true,
          ...vm.calcAxisRange(chartData, 'loginCnt'),
          labels: {
            position: 'end',
            template: `#= kendo.format('{0:N0}', value) # 건 `
          }
        }
      }
    },
    /**
     * 응답의 date(yyyy/MM/dd)로 차트 카테고리 라벨을 만든다.
     * 날짜가 30~366개까지 늘어날 수 있어 전부 'M/d' 로 찍으면 축이 겹친다.
     * 그래서 월이 바뀌는 날만 'M/d', 나머지는 'd' 로 표기한다.
     * (기존 통계화면 ReportLocationList 의 표기 규약과 동일)
     */
    toCategoryData: function (dailyStatList) {
      const list = Array.isArray(dailyStatList) ? dailyStatList : []

      return list.map((item, i) => {
        const parts = item.date.split('/')
        const prevParts = i === 0 ? null : list[i - 1].date.split('/')
        const isChangeMonth = i === 0 || parts[1] !== prevParts[1]

        return {
          ...item,
          category: isChangeMonth ? `${Number(parts[1])}/${Number(parts[2])}` : `${Number(parts[2])}`,
          MMdd: `${parts[1]}/${parts[2]}`
        }
      })
    },
    /**
     * 값축의 min / max / 구분선 간격을 계산한다.
     * 최대값을 그대로 max 로 쓰면 최고점 막대의 위쪽이 잘려 보이므로 한 단위 올림한다.
     * (기존 통계화면 ReportLocationList 의 계산식과 동일)
     */
    calcAxisRange: function (chartData, field) {
      if (!chartData.length) {
        return { min: 0, max: 5, majorUnit: 1 }
      }

      const maxCnt = chartData.reduce((prev, current) => (prev[field] > current[field] ? prev : current))[field]

      // 최대값이 5보다 작으면 보조값이 0 0 0 1 1 처럼 중복 표기된다.
      if (maxCnt < 5) {
        return { min: 0, max: 5, majorUnit: 1 }
      }

      const num = 10 ** (maxCnt.toString().length === 1 ? 1 : maxCnt.toString().length - 1)
      const max = Math.ceil(maxCnt * 1.001 / num) * num

      return { min: 0, max: max, majorUnit: max / 5 }
    },
    cleanSearchDataEvent: function () {
      const vm = this
      const refs = vm.$refs

      refs.cmpyCdRef?.widget().value('')
      refs.dtRef?.widget().range({ start: vm.defaultStartDate, end: new Date() })

      vm.propsCmpyCd = ''
      vm.allApiCall()
    }
  },
  data () {
    const constant = {
      total: '전체 접속',
      login: '로그인',
      totalAxis: 'TOTAL',
      loginAxis: 'LOGIN'
    }

    // 기본 조회기간은 최근 30일. 서버 기본값(DEFAULT_PERIOD_DAYS)과 맞춘다.
    const defaultStartDate = new Date()
    defaultStartDate.setDate(defaultStartDate.getDate() - 29)

    return {
      Constant,
      constant: constant,
      ApiConfig: ApiConfig,
      defaultStartDate: defaultStartDate,
      propsCmpyCd: '',
      chartTransitions: true,
      stats: {
        totalCnt: 0,
        userCnt: 0,
        loginCnt: 0,
        errCnt: 0,
        avgProcMs: 0,
        searchStartYYYYMMDD: '',
        searchEndYYYYMMDD: '',
        dailyStatList: []
      },
      totalChartData: {
        series: {},
        valueAxis: {}
      },
      loginChartData: {
        series: {},
        valueAxis: {}
      }
    }
  },
  mounted () {
    // 회사 드롭다운이 default-index 0 으로 첫 회사를 선택하면서 change 를 쏘지만,
    // 선택 가능한 회사가 없는 계정은 change 가 오지 않으므로 빈 상태를 명시적으로 그려둔다.
    this.setChartData([])
  }
}
</script>

<style scoped>
/*
 * 공통 CSS(ebmp.css / fms.css)는 원격 디자인 서버에서 로드되므로 이 화면에서 클래스를 추가할 수 없다.
 * 컨테이너(contents_wrap / small_title_wrap / box_flex)는 공통 클래스를 그대로 쓰고,
 * 요약 카드의 숫자 표기만 이 화면에서 정의한다.
 */
.acs_stat_value {
  margin: 14px 0 4px;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  text-align: right;
  word-break: break-all;
}

.acs_stat_value.blue { color: #4b79d8; }
.acs_stat_value.green { color: #008b14; }
.acs_stat_value.red { color: #d63031; }
.acs_stat_value.gray { color: #555555; }

.acs_stat_unit {
  margin-left: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #888888;
}

.acs_stat_desc {
  margin-bottom: 6px;
  font-size: 12px;
  color: #888888;
  text-align: right;
}

.acs_stat_period {
  margin-left: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #888888;
}
</style>
